module.exports = __webpack_public_path__ + "img/snorkeling-12.ebbce5be.jpeg";